export const NAME = 'shrinkWrappingTypes';